/**
 * Initialize Pinia stores on app startup (client-side only)
 */
export default defineNuxtPlugin(async () => {
  // Guard against missing Supabase configuration
  try {
    const user = useSupabaseUser()
    if (!user.value) return
  } catch {
    console.warn('Supabase not configured, skipping store initialization')
    return
  }

  const userStore = useUserStore()
  const subscriptionStore = useSubscriptionStore()
  const companyStore = useCompanyStore()
  const usageStore = useUsageStore()

  try {
    await userStore.initializeFromAuth()
  } catch {
    console.warn('Failed to initialize user store')
    return
  }

  if (userStore.isAuthenticated) {
    await userStore.fetchProfile(true).catch((error) => {
      console.warn('Failed to fetch user profile during initialization:', error)
    })

    try {
      await companyStore.fetchCompanyData().catch((error) => {
        console.warn('Background company fetch failed:', error)
      })

      subscriptionStore.checkSubscription().catch((error) => {
        console.warn('Background subscription check failed:', error)
      })

      // Not gated on hasCurrentCompany: a failed company fetch used to
      // leave the sidebar showing the seeded plan forever. The usage
      // endpoint resolves the workspace itself and doesn't need the store.
      usageStore.fetchUsageData().catch((error) => {
        console.warn('Background usage fetch failed:', error)
      })
    } catch (error) {
      console.warn('Store initialization failed:', error)
    }
  }
})
